import React from 'react'
import BaseInput from '../../General/FormsComp/Input/BaseInput'

const FinanceiroCadastro = ({ newClient, handleInputChange }) => {
    return (
        <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
            <BaseInput
                label="Responsável Financeiro"
                name="responsavel_financeiro"
                value={newClient?.responsavel_financeiro}
                onChange={handleInputChange}
                type="text"
            />

            <BaseInput
                label="Telefone Financeiro"
                name="telefone_financeiro"
                value={newClient?.telefone_financeiro}
                onChange={handleInputChange}
                type="tel"
            />

            <BaseInput
                label="E-mail de recebimento de NF"
                name="email_responsalvel_financeiro"
                value={newClient?.email_responsalvel_financeiro}
                onChange={handleInputChange}
                type="email"
            />

            <p className="aviso-contratos md:col-span-2 text-sm italic text-gray-600 dark:text-gray-300 bg-gray-50 dark:bg-gray-700/40 border border-gray-200 dark:border-gray-600 rounded-lg p-4">
                Valor e tipo agora são definidos por contrato — cadastre o cliente e depois
                crie os contratos na aba "Contratos".
            </p>
        </div>
    )
}

export default FinanceiroCadastro
